module.exports = __webpack_public_path__ + "img/pro-manage3.c49c730c.png";